import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-light py-5">
      <div className="container">
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-md-3">
            <div className="d-flex">
              <img
                src="https://i.ibb.co/gRbpHvh/Pngtree-2-lipstick-cosmetics-in-carrot-5983549.png"
                alt="logo"
                width="90"
                height="90"
                className=""
              />
              <h1 className="navbar-brand fw-bold fst-italic">
                LIZA'S <br />
                LIPSTICKS <br />
                LTD.
              </h1>
            </div>
            <p>
              Your favourite lipsticks - all in one place! Offering a wide range
              of collections, suitable for all kinds of tastes. The most trusted
              company for over 10 years!
            </p>
            <h6>Follow Us:</h6>
            <div
              className="d-flex justify-content-start social-links"
              style={{ fontSize: "1.5em" }}
            >
              <a target="_blank" rel="noreferrer" href="https://facebook.com">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a target="_blank" rel="noreferrer" href="https://instagram.com">
                <i className="fab fa-instagram"></i>
              </a>

              <a target="_blank" rel="noreferrer" href="https://twitter.com">
                <i className="fab fa-twitter"></i>
              </a>
              <a target="_blank" rel="noreferrer" href="https://youtube.com">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>
          <div className="col-md-3">
            <h4>Contact Us</h4>
            <div className="d-flex ">
              <i className="fas fa-phone-alt align-self-center me-2"></i>
              <p className="ms-1 mb-0">
                +8801771234567 <br />
                +8801771234568
              </p>
            </div>
            <br />
            <div className="d-flex">
              <i className="fas fa-envelope align-self-center me-2"></i>
              <p className="ms-1 mb-0 fs-6">
                info@liza-lips.com <br />
                support@liza-lips.com
              </p>
            </div>
            <br />
            <div className="d-flex">
              <i className="fas fa-map-marker-alt align-self-center me-2"></i>
              <p className="ms-1 mb-0">
                1234 Narnia Street <br />
                Neverland, Narnia
              </p>
            </div>
          </div>
          <div className="col-md-3">
            <h4>Quick Links</h4>
            <div>
              <ul className="list-unstyled">
                <li>
                  <Link
                    to="/home"
                    style={{ textDecoration: "none" }}
                    className="text-dark"
                  >
                    Home
                  </Link>
                </li>
                <br />
                <li>
                  <Link
                    to="/destinations"
                    style={{ textDecoration: "none" }}
                    className="text-dark"
                  >
                    Products
                  </Link>
                </li>
                <br />
                <li>
                  <Link
                    to="/login"
                    style={{ textDecoration: "none" }}
                    className="text-dark"
                  >
                    Login
                  </Link>
                </li>
                <br />
                <li>
                  <Link
                    to="/signup"
                    style={{ textDecoration: "none" }}
                    className="text-dark"
                  >
                    Sign Up
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-3">
            <h4 className=" mb-4">We accept:</h4>

            <div className="d-flex flex-wrap justify-content-start payment-links">
              <i className="fab fa-cc-visa"></i>
              <i className="fab fa-cc-mastercard"></i>
              <i className="fab fa-cc-paypal"></i>
              <i className="fab fa-cc-amex"></i>
              <i className="fab fa-cc-stripe"></i>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
